module.exports = __webpack_public_path__ + "static/21-09-28_11-49-48_6964-ace3a61fcc63273f12b46493120cc4bf.jpg";